module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-it-IT.e8eaf239.jpg";